import React from 'react';
import CsInquiryDetailUserInfo from '../CsInquiryDetailUserInfo';
import CsInquiryDetailInfo from '../CsInquiryDetailInfo';

const CsInquiryDetailWrap = (props) => {
  const { form, setData, csInquiryDetail, getUsersOtherInquiryList, onReply } = props;
  const { userInfo, inquiryInfo } = csInquiryDetail;

  return (
    <div className="cs-inquiry-detail-wrap">
      {/*유저 정보*/}
      <CsInquiryDetailUserInfo userInfo={userInfo} getUsersOtherInquiryList={getUsersOtherInquiryList} />

      {/*1:1 문의 정보*/}
      <CsInquiryDetailInfo form={form} setData={setData} inquiryInfo={inquiryInfo} onReply={onReply} />
    </div>
  );
};

export default CsInquiryDetailWrap;
